import {useQueries} from "@tanstack/react-query";
import eventService from "../../../../services/web/alarm-system-service.js";

const UseFetchOptions = () => {

    const queries = useQueries({
        queries: [
            {
                queryKey: ['reportcode'],
                queryFn: () => eventService.getEventsType(),
                initialData: []
            }
        ]
    });

    return {
        reportCodeOptions: queries[0].data
    };
};

export default UseFetchOptions;